export const ErrorMessages = {
  1: 'Você não está autorizado a acessar a página solicitada.'
}
